import { render } from "./hotelMonitor.vue?vue&type=template&id=531baf3a&scoped=true"
import script from "./hotelMonitor.vue?vue&type=script&lang=js"
export * from "./hotelMonitor.vue?vue&type=script&lang=js"

import "./hotelMonitor.vue?vue&type=style&index=0&id=531baf3a&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531baf3a"]])

export default __exports__